module.exports = __webpack_public_path__ + "static/GE_Module_4-228c421557c368a350919e6faa3b9120.png";